import { marked } from 'marked';
import DOMPurify from 'dompurify';

export const get_numbers = (input: string): number[] => {
    var ret = input.toString().match(/[0-9]+/g);
    if (ret == null) {
        return [];
    }

    return ret.map(x => parseInt(x));
};

export const convertMarkdown = (markdown: string): string => {
    if (!markdown) {
        return 'ERROR: No message content';
    }

    const rawHtmlWithDefault = marked.parse(markdown as string) as string;
    return DOMPurify.sanitize(rawHtmlWithDefault as string);
};
